import { gql } from '@apollo/client';

const FETCH_DEPOSIT_DETAIL = gql`
  query DepositDetail($depositId: String!) {
    depositDetail(depositId: $depositId) {
      id
      code
      money
      percenthouse
      percentcashier
      profithouse
      currentusd
      profitcashier
      totaltopay
      motive
      timeinhour
      currency
      comment
      status
      createdAt
      updatedAt
      usedAcceleration
      destinyProcessor {
        id
        type
        name
        photoUrl
        paymentmethod
        enablewithdraw
        status
        createdAt
        updatedAt
      }    
      accountsendstringify  
      systemProcessor {
        id
        type
        name
        photoUrl
        paymentmethod
        enablewithdraw
        status
        createdAt
        updatedAt
      }
      user {
        id
        fullname
        email
        phone
        country
        photoUrl
        lastConnection
      }
      cashier {
        id
        fullname
        photoUrl
        nickname
        lastConnection
      } 
      depositAppeal{
        id
        commentByCashier
        commentByUser
        commentByAdmin
        demandByCashier
        demandByUser
        status
        updatedAt
        createdAt
      }
 
    }
  }
`;

export default FETCH_DEPOSIT_DETAIL;